<template>
  <v-dialog
    v-model="show"
    max-width="800px"
    @click:outside="$_clearHashRoute()"
  >
    <v-card>
      <v-card-title v-if="tipo === 'erro'" class="headline red darken-3 white--text">Erros de Validação</v-card-title>
      <v-card-title v-else class="headline orange darken-3 white--text">Aviso</v-card-title>
      <v-card-text class="pt-4">
        <p v-if="tipo === 'erro'" class="subtitle-1">Foram encontrados os seguintes erros ao finalizar a ordem de carregamento:</p>
        <p v-else class="subtitle-1">Quantidade prevista diferente da carregada:</p>
        <div class="card-container">
          <v-card
            v-for="(item, index) in formattedItems"
            :key="index"
            class="mb-3"
            outlined
            color=""
            elevation="2"
            style="cursor: pointer;"
          >
            <v-card-title class="subtitle-1">
              {{ item.produto }} ({{ item.codigo }})
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <!-- <p><strong>Erro:</strong> {{ item.erro }}</p> -->
              <template v-if="item.erro !== 'Unidades não conferem'">
                <p><strong>Quantidade Definida:</strong> {{ FormataQuantVirgula(item.somaOriginal, 2) }}.</p>
                <p><strong>Quantidade Inserida:</strong> {{ FormataQuantVirgula(item.somaErrada, 2) }}.</p>
              </template>
              <div v-if="item.diferencas && item.diferencas.length > 0">
                <p class="font-weight-bold mt-3">Unidades com divergência:</p>
                
                <simplebar data-simplebar :autoHide="false" :style="{height: 100 + '%'}">
                  <!-- <table :style="{ width: unidadesInseridas.length > 0 ? 100 + '%' : 100 + '%' }"> -->
                  <table :style="{ width: 100 + '%' }">
                    <tr class="table__tr--header" ref="simplebar">

                      <th class="px-2">
                        LOTE
                      </th>
                      <th class="px-2">
                        NU
                      </th>
                      <th class="px-2">
                        QUANTIDADE
                      </th>
                      <th class="px-2">
                        LOCAL
                      </th>
                    </tr>
                  <template v-for="(value, index) in item.diferencas">
                      <tr :class="{
                        'table__tr': true,
                        'table__tr--dark-background': index % 2 == 0,
                        }"
                        :key="index" >
                        <td  >{{value.oculote}}</td >
                        <td  v-if="value.ocunumerobag">{{value.ocunumerobag}}</td >
                        <td  v-else>- - -</td >
                        <td  >{{FormataQuantVirgula(value.ocuquantidade, 2)}}</td >
                        <td  >{{value.oculocal}}</td >
                      </tr>
                  </template>
                  
                </table>
              </simplebar>

              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          color="red darken-1"
          text
          @click="$emit('validacaoContinuar')"
        >
          Continuar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="show = false, $_clearHashRoute()"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

export default {
  name: 'ValidationDialog',
  components: {
    simplebar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: 'erro',
    }, 
    validacaoData: {
      type: Array,
      default: () => [
        // Mock data for "different units" error
        {
          item: {
            ociidnuvem: "4647b131-c976-4694-996e-25c3a4824d40",
            ociidordemcarregamentoitem: 1,
            ociprodutocodigo: 'P-01',
            ociproduto: 'PRODUTO DE TESTE 1',
            ociquantidade: '1000.00',
          },
          resultadoUnidades: {
            diferencas: [
              { oculote: 'LOTE-A', ocunumerobag: 1, ocuquantidade: '250.00', oculocal: 'LOC-01' },
              { oculote: 'LOTE-B', ocunumerobag: 2, ocuquantidade: '250.00', oculocal: 'LOC-02' },
            ],
            resultado: false,
          },
          resultadoQuantidade: {
            soma: 500,
            resultado: true,
          },
        },
        // Mock data for "incorrect quantity" error
        {
          item: {
            ociidnuvem: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
            ociidordemcarregamentoitem: 2,
            ociprodutocodigo: 'P-02',
            ociproduto: 'PRODUTO DE TESTE 2',
            ociquantidade: '2000.00',
          },
          resultadoUnidades: {
            diferencas: [],
            resultado: true,
          },
          resultadoQuantidade: {
            soma: 1500,
            resultado: false,
          },
        },
      ],
    },
  },
  data() {
    return {
      expandedCards: {},
      unidadesHeaders: [
        { text: 'Lote', value: 'oculote', sortable: false },
        { text: 'Bag', value: 'ocunumerobag', sortable: false },
        { text: 'Qtd', value: 'ocuquantidade', sortable: false },
        { text: 'Local', value: 'oculocal', sortable: false },
      ],
    };
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    formattedItems () {
      return this.validacaoData.map(v => {
        let erro = ''
        if (!v.resultadoQuantidade.resultado) {
          erro = 'Divergência na quantidade.'
        } else if (!v.resultadoUnidades.resultado) {
          erro = 'Unidades não conferem.'
        }
        return {
          codigo: v.item.ociprodutocodigo,
          produto: v.item.ociproduto,
          erro,
          somaOriginal: v.item.ociquantidade,
          somaErrada: !v.resultadoQuantidade.resultado ? v.resultadoQuantidade.soma : '-',
          diferencas: v.resultadoUnidades.diferencas,
        }
      })
    },
  },

  methods: {
    async $_clearHashRoute() {
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '',
      }).catch(() => {});
    },
    FormataQuantVirgula(valor) {
      let quant = (valor);
      quant = Number(quant - 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
      return quant;
    },
  }

}
</script>

<style scoped>
.card-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}
p {
  margin-bottom: 8px;
}
  .table__tr > td {
    text-align: center;
    padding-block: 2px;
    font-size: 0.85rem;
  }

.table__tr {
  transition: transform 0.2s;
  /* // border: 1px solid red; */
}

.table__tr:not(.table__tr--header):hover {
  background-color: #e6ded9;
  cursor: pointer;
}

.table__tr--dark-background {
  background-color: #eee;
}

.table__tr--header {
  background-color: #eb2005;
  color: white;
}

/deep/ .simplebar-scrollbar::before{
  background-color: #eb2005 !important;
}
/deep/ .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}
</style>
